
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SEOHead from '../../components/SEO/SEOHead';

export default function PartnersPage() {
  const { t } = useTranslation();

  const seoData = {
    title: 'شرکای گلخانه سبز آریا - همکاری با برندهای معتبر بین‌المللی | Vander Hoeven',
    description: 'آشنایی با شرکای تجاری گلخانه سبز آریا شامل شرکت‌های معتبر هلندی و بین‌المللی. همکاری با Vander Hoeven و سایر برندهای مطرح صنعت گلخانه‌سازی جهان.',
    keywords: 'شرکای گلخانه آریا، همکاری بین‌المللی، Vander Hoeven، شرکای هلندی، برندهای معتبر گلخانه، همکاری تجاری، شرکای استراتژیک، تأمین‌کنندگان بین‌المللی، فناوری هلندی',
    ogImage: 'https://public.readdy.ai/ai/img_res/711954ed04a5c1d3370ce4a1057036e5.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "شرکای گلخانه سبز آریا",
      "description": "معرفی شرکای تجاری و همکاران بین‌المللی",
      "mainEntity": {
        "@type": "Organization",
        "name": "گلخانه سبز آریا",
        "partner": [
          {
            "@type": "Organization",
            "name": "Vander Hoeven",
            "description": "شرکت هلندی تولیدکننده تجهیزات پیشرفته گلخانه",
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "NL"
            }
          },
          {
            "@type": "Organization",
            "name": "چهل ستون",
            "description": "شریک داخلی در تأمین مواد اولیه",
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "IR"
            }
          }
        ]
      }
    }
  };

  const partners = [
    {
      id: 1,
      name: 'Priva',
      country: 'هلند',
      specialty: 'سیستم‌های کنترل اقلیم',
      description: 'رهبر جهانی در تولید سیستم‌های کنترل اقلیم و اتوماسیون گلخانه',
      image: 'https://readdy.ai/api/search-image?query=Modern%20greenhouse%20climate%20control%20systems%20Dutch%20technology%20Priva%20automation%20equipment%20professional%20industrial%20setting&width=400&height=300&seq=partner-priva&orientation=landscape',
      website: 'www.priva.com',
      established: '1959'
    },
    {
      id: 2,
      name: 'Ridder',
      country: 'هلند',
      specialty: 'سیستم‌های آبیاری هوشمند',
      description: 'متخصص در سیستم‌های آبیاری دقیق و کنترل تغذیه گیاهان',
      image: 'https://readdy.ai/api/search-image?query=Smart%20irrigation%20systems%20greenhouse%20Dutch%20technology%20Ridder%20water%20management%20equipment%20modern%20agricultural%20technology&width=400&height=300&seq=partner-ridder&orientation=landscape',
      website: 'www.ridder.com',
      established: '1965'
    },
    {
      id: 3,
      name: 'Venlo Glasshouse',
      country: 'هلند',
      specialty: 'ساخت گلخانه شیشه‌ای',
      description: 'سازنده گلخانه‌های شیشه‌ای مدرن با فناوری پیشرفته',
      image: 'https://readdy.ai/api/search-image?query=Modern%20glass%20greenhouse%20construction%20Dutch%20Venlo%20style%20architecture%20transparent%20glass%20panels%20steel%20structure%20professional%20building&width=400&height=300&seq=partner-venlo&orientation=landscape',
      website: 'www.venlo-glasshouse.nl',
      established: '1970'
    },
    {
      id: 4,
      name: 'Netafim',
      country: 'اسرائیل',
      specialty: 'آبیاری قطره‌ای',
      description: 'پیشگام جهانی در فناوری آبیاری قطره‌ای و هیدروپونیک',
      image: 'https://readdy.ai/api/search-image?query=Drip%20irrigation%20system%20greenhouse%20Israeli%20technology%20Netafim%20water%20efficient%20agriculture%20modern%20farming%20equipment&width=400&height=300&seq=partner-netafim&orientation=landscape',
      website: 'www.netafim.com',
      established: '1965'
    },
    {
      id: 5,
      name: 'Svensson',
      country: 'سوئد',
      specialty: 'پرده‌های اقلیمی',
      description: 'تولیدکننده پرده‌های اقلیمی و سیستم‌های سایه‌اندازی گلخانه',
      image: 'https://readdy.ai/api/search-image?query=Greenhouse%20climate%20screens%20Swedish%20technology%20Svensson%20shade%20systems%20energy%20saving%20curtains%20modern%20agricultural%20textiles&width=400&height=300&seq=partner-svensson&orientation=landscape',
      website: 'www.svensson.com',
      established: '1923'
    },
    {
      id: 6,
      name: 'Grodan',
      country: 'هلند',
      specialty: 'بسترهای کشت',
      description: 'تولیدکننده بسترهای کشت پشم سنگی برای کشت هیدروپونیک',
      image: 'https://readdy.ai/api/search-image?query=Hydroponic%20growing%20media%20rockwool%20substrates%20Dutch%20technology%20Grodan%20cultivation%20systems%20modern%20greenhouse%20growing&width=400&height=300&seq=partner-grodan&orientation=landscape',
      website: 'www.grodan.com',
      established: '1969'
    }
  ];

  const achievements = [
    {
      number: '50+',
      title: 'شریک بین‌المللی',
      description: 'همکاری با بهترین برندهای جهان'
    },
    {
      number: '25+',
      title: 'سال تجربه',
      description: 'در زمینه واردات و توزیع'
    },
    {
      number: '1000+',
      title: 'پروژه موفق',
      description: 'با استفاده از تجهیزات شرکا'
    },
    {
      number: '15',
      title: 'کشور',
      description: 'شرکای ما در سراسر جهان'
    }
  ];

  return (
    <div className="min-h-screen">
      <SEOHead {...seoData} />
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-cover bg-center pt-24 mt-20"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Business%20partnership%20meeting%20greenhouse%20industry%20professionals%20handshake%20cooperation%20international%20collaboration%20agricultural%20technology&width=1920&height=600&seq=partners-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 lg:px-8 text-center text-white">
          <h1 className="text-5xl lg:text-6xl font-bold mb-6">
            شرکای ما
          </h1>
          <p className="text-xl lg:text-2xl max-w-3xl mx-auto">
            همکاری با بهترین شرکت‌های بین‌المللی در صنعت گلخانه
          </p>
        </div>
      </section>

      {/* Achievements Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              دستاوردهای ما
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              نتیجه سال‌ها همکاری با بهترین برندهای جهان
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {achievements.map((achievement, index) => (
              <div key={index} className="text-center bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="text-4xl font-bold text-green-600 mb-4">
                  {achievement.number}
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  {achievement.title}
                </h3>
                <p className="text-gray-600">
                  {achievement.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              شرکای بین‌المللی
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              با فناوری هلندی و کیفیت جهانی، بهترین تجهیزات را به شما ارائه می‌دهیم
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {partners.map((partner) => (
              <div key={partner.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <div className="h-48 bg-cover bg-center"
                  style={{ backgroundImage: `url('${partner.image}')` }}
                ></div>
                <div className="p-6">
                  <div className="flex justify-between items-start mb-4">
                    <h3 className="text-2xl font-bold text-gray-800">
                      {partner.name}
                    </h3>
                    <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                      {partner.country}
                    </span>
                  </div>
                  
                  <div className="mb-4">
                    <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                      {partner.specialty}
                    </span>
                  </div>
                  
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {partner.description}
                  </p>
                  
                  <div className="flex justify-between items-center text-sm text-gray-500">
                    <span>تاسیس: {partner.established}</span>
                    <span className="text-blue-600 hover:text-blue-800 cursor-pointer">
                      {partner.website}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partnership Benefits */}
      <section className="py-20 bg-gradient-to-br from-green-50 to-blue-50">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              مزایای همکاری با ما
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              چرا بهترین برندهای جهان ما را به عنوان نماینده انتخاب کرده‌اند؟
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-lg text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-award-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                کیفیت تضمین شده
              </h3>
              <p className="text-gray-600">
                تمام محصولات دارای گارانتی بین‌المللی و پشتیبانی کامل
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-global-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                شبکه جهانی
              </h3>
              <p className="text-gray-600">
                دسترسی به آخرین فناوری‌ها و نوآوری‌های صنعت گلخانه
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-customer-service-2-line text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                پشتیبانی ۲۴/۷
              </h3>
              <p className="text-gray-600">
                تیم متخصص ما همیشه آماده ارائه مشاوره و خدمات فنی
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-price-tag-3-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                قیمت رقابتی
              </h3>
              <p className="text-gray-600">
                بهترین قیمت‌ها با حذف واسطه‌ها و واردات مستقیم
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-truck-line text-3xl text-red-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                تحویل سریع
              </h3>
              <p className="text-gray-600">
                انبار مجهز و سیستم لجستیک پیشرفته برای تحویل به موقع
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-tools-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                نصب و راه‌اندازی
              </h3>
              <p className="text-gray-600">
                تیم متخصص برای نصب، راه‌اندازی و آموزش کاربران
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 bg-gray-800 text-white">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">
            آماده همکاری با ما هستید؟
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            با تیم ما تماس بگیرید و از مشاوره رایگان برای انتخاب بهترین تجهیزات استفاده کنید
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href="/contact" 
               className="bg-green-600 hover:bg-green-7

0 text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors whitespace-nowrap">
              تماس با ما
            </a>
            <a href="tel:02188441386" 
               className="bg-transparent border-2 border-white hover:bg-white hover:text-gray-800 text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors whitespace-nowrap">
              ۰۲۱۸۸۴۴۱۳۸۶
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
